const version ='0.3.12'
export default version
console.log(version)
